import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { RasaContext } from 'context'
import { isFalsey } from 'generic/utility'
import React from 'react'
import * as Modals from 'shared/modals'
import { Input } from 'reactstrap'

interface AddBlastModalState extends Modals.ModalComponentState {
  isDirty: boolean,
}

interface AddBlastModalProps extends Modals.ModalComponentProps {
  onSave: (data: any) => Promise<any>
}

export class AddBlastModal
  extends Modals.GenericModalComponent<AddBlastModalProps, AddBlastModalState> {
  public static key: string = 'addBlast'
  public static contextType = RasaContext

  constructor(props: any) {
    super(props, AddBlastModal.key, 'Add Blast')
  }

  protected renderChildren(data: any) {
    const { modalType } = data

    if (modalType === 'schedule') {
      return this.renderScheduleModal(data)
    }

    return this.renderAddEditModal(data)
  }

  private renderScheduleModal(data: any) {
    const { start_date } = data
    const minDate = new Date()
    minDate.setMinutes(minDate.getMinutes() + 5)

    return <div className="add-blast-modal-content">
      <div className="blast-row-container">
        <h5 className="heading">Send Date</h5>
        <div className="blast-row-inner-container">
          <DateTimePicker
            format="MM/dd/yyyy hh:mm a"
            value={start_date ? start_date : null}
            min={minDate}
            onChange={(e) => this.updateProperty('start_date', e.target.value)}
          />
        </div>
      </div>
    </div>
  }

  private renderAddEditModal(data: any) {
    const { name, description, subject, preview } = data

    return <div className="add-blast-modal-content">
      <div className="blast-row-container">
        <h5 className="heading">Name</h5>
        <div className="blast-row-inner-container">
          <Input
            type="text"
            value={name || ''}
            onChange={(e) => this.updateProperty('name', e.target.value)}
            placeholder="Enter blast name"
          />
        </div>
      </div>
      <div className="blast-row-container">
        <h5 className="heading">Description</h5>
        <div className="blast-row-inner-container">
          <Input
            type="textarea"
            value={description || ''}
            onChange={(e) => this.updateProperty('description', e.target.value)}
            placeholder="Enter blast description"
            rows={4}
          />
        </div>
      </div>
      <div className="blast-row-container">
        <h5 className="heading">Subject</h5>
        <div className="blast-row-inner-container">
          <Input
            type="text"
            value={subject || ''}
            onChange={(e) => this.updateProperty('subject', e.target.value)}
            placeholder="Enter email subject"
          />
        </div>
      </div>
      <div className="blast-row-container">
        <h5 className="heading">Preview</h5>
        <div className="blast-row-inner-container">
          <Input
            type="textarea"
            value={preview || ''}
            onChange={(e) => this.updateProperty('preview', e.target.value)}
            placeholder="Enter email preview text"
            rows={3}
          />
        </div>
      </div>
    </div>
  }

  protected getTitleText(data: any): string {
    if (data.modalType === 'schedule') {
      return 'Schedule Blast'
    }
    if (data.modalType === 'edit') {
      return 'Edit Blast'
    }
    return 'Add Blast'
  }

  protected getSaveText(data: any): string {
    return 'Save'
  }

  protected getCloseText(data: any): string {
    return 'Cancel'
  }

  protected saveDisabled(data: any): boolean {
    if (data.modalType === 'schedule') {
      if (!data.start_date) {
        return true
      }
      const minDate = new Date()
      minDate.setMinutes(minDate.getMinutes() + 5)
      const selectedDate = new Date(data.start_date)
      return selectedDate < minDate
    }
    const { name, description } = data
    return isFalsey(name) || isFalsey(description)
  }

  protected updateProperty(property, value) {
    this.props.updateModal(AddBlastModal.key, {
      name: property,
      value,
    })
    this.setState({ isDirty: !this.state.isDirty })
  }

  protected doSave(data: any) {
    return this.props.onSave(data)
      .then(() => {
        this.setState({})
        this.props.closeModal(AddBlastModal.key)
        return Promise.resolve({})
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  }
}
